
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const Forceclose = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onClickCriticalConsignment(props);
    };
    

    return (
        <div>
            <button onClick={handleEventClick} className="btn btn-info custom-btn white f13" 
            title="Critical" > Critical</button>
            
        </div>
    );
};

export default Forceclose;
